import { BodyText } from '@unmind/design-system';
import {
  CircleInfo,
  HeadphonesWithMicrophone,
  Office,
  Review,
  SolidLifebuoy,
  SolidLock,
  Sparkles,
} from 'icons';
import styled, { css } from 'styled-components';

export const DisclaimerContainerWrapper = styled.div<{
  $inModal: boolean;
}>`
  ${({ $inModal }) =>
    !$inModal &&
    css`
      & > div:last-child {
        padding-bottom: 0;
      }
    `}
`;

export const DisclaimerContainer = styled.div<{
  $isFirst?: boolean;
  $isLast?: boolean;
}>`
  display: flex;
  flex-direction: row;

  ${({ $isLast, theme }) =>
    !$isLast &&
    css`
      border-bottom: 1px solid ${theme.colors.border.secondary};
      padding-bottom: 16px;
    `}
  ${({ $isFirst }) =>
    !$isFirst &&
    css`
      padding-top: 16px;
    `};
`;

export const DisclaimerText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize14],
}))`
  flex: 1;
`;

export const DisclaimerLink = styled(BodyText).attrs(({ theme }) => ({
  forwardedAs: 'a',
  sizes: [theme.typography.fontSizes.fontSize14],
}))`
  display: inline-block;
`;

export const DisclaimerIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-right: 8px;
`;

const iconStyles = {
  width: 16,
  height: 16,
};

export const IntendedPurposeIcon = styled(CircleInfo).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const AIGeneratedIcon = styled(Sparkles).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const MedicalDisclaimerIcon = styled(SolidLifebuoy).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.text.primary,
    ...iconStyles,
  }),
)``;

export const OfficeIcon = styled(Office).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const ConfidentialityIcon = styled(SolidLock).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const AnonymityIcon = styled(Review).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  ...iconStyles,
}))``;

export const HeadphonesIcon = styled(HeadphonesWithMicrophone).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.text.primary,
    ...iconStyles,
  }),
)``;
